import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ViewStateOptions } from '@src/suite/common/data-models/navigation/viewstate-options';
import { ViewStateRecord } from '@src/suite/common/data-models/records/viewstate-record';
import { ViewStateTypesEnum } from '@src/suite/common/enums/viewstate-types';
import { NavigationGroup, NavigationItem, NavigationSection } from '@src/suite/common/store/navigation/models/navigation.models';

export const CreateViewStateActions = createActionGroup({
    source: 'Create view state',
    events: {
        'Initialize view state': props<{
            vstype: number;
            copy: boolean;
            edit: boolean;
            vs: ViewStateRecord;
            group: NavigationGroup;
            section: NavigationSection;
            item: NavigationItem;
            title?: string;
        }>(),
        'Initialize view state success': props<{
            vstype: number;
            copy: boolean;
            edit: boolean;
            vs: ViewStateRecord;
            group: NavigationGroup;
            section: NavigationSection;
            item: NavigationItem;
            layout: ViewStateOptions;
            groupby: ViewStateOptions;
            sortby: ViewStateOptions;
            title?: string;
        }>(),
        'Initialize view state error': props<{ error: string }>(),
        'Update view state type': props<{ vstype: number }>(),
        'Update view state title': props<{ title: string }>(),
        'Update view state layout': props<{ layout: string }>(),
        'Update view state group by': props<{ groupBy: string }>(),
        'Update view state group by sort order': emptyProps(),
        'Update view state sort by': props<{ sortBy: string }>(),
        'Update view state sort by sort order': emptyProps(),
        'Toggle sort oder': emptyProps(),
        'Toggle group sort oder': emptyProps(),
        'Add view state filters': props<{ required: boolean; filters: Array<string> }>(),
        'Remove view state filter': props<{ required: boolean; filter: string }>(),
        'Remove all view state filters': props<{ required: boolean }>(),
        'Update view state filter': props<{ required: boolean }>(),

        'Save view state': emptyProps(),
        'Save view state success': props<{ vs: ViewStateRecord }>(),
        'Save view state error': props<{ error: string }>(),

        // Topic & assignment view state
        'Update view state custom card fields': props<{ fields: Array<FieldDef> }>(),
        'Update view state lock map location': props<{ locked: boolean }>(),
        'Update view state map show team locations': props<{ show: boolean }>(),
        'Update view state map zoom to coverage': props<{ zoom: boolean }>(),
        'Update view state slideshow delay': props<{ delay: number }>(),
        'Update view state slideshow sequence': props<{ guid: string; checked: boolean }>(),

        // Publication view state
        'Update view state show topics': props<{ show: boolean }>(),
        'Update view state show assignments': props<{ show: boolean }>(),
        'Update view state show stories': props<{ show: boolean }>(),
        'Update view state remove added records': props<{ remove: boolean }>(),
        'Update view state guid': props<{ guid: string }>(),
        'Update view state publication channel guid': props<{ guid: string }>(),
        'Update view state edition name': props<{ name: string }>(),
        'Update view state publication list title': props<{ title: string }>(),
        'Update view state publication time': props<{ time: string }>(),

        // Discover view state
        'Update view state feed url': props<{ url: string }>(),
        'Update view state feed id': props<{ id: string }>(),
        'Update view state twitter usernames': props<{ usernames: Array<string> }>(),
        'Update view state sequence': props<{ selected: Array<string>; unselected: Array<string> }>(),

        'Cancel add view states': emptyProps(),
        'Save add view states': emptyProps(),
        'Save add view states success': emptyProps(),
        'Save add view states error': props<{ error: string }>(),

        'Remove all view states': emptyProps(),
        'Remove view state': props<{ guid: string }>(),

        'Enter browse mode': emptyProps(),
        'Enter browse mode success': emptyProps(),
        'Enter browse mode error': props<{ error: string }>(),
        'Enter configure mode': emptyProps(),

        'Load stored view states': props<{ vsType: ViewStateTypesEnum }>(),
        'Set stored view states': props<{ viewStates: Array<ViewStateRecord> }>(),
    },
});
